import * as graph from '@adc/sdk'
// @ts-ignore no types
import _, { get } from 'lodash'
// @ts-ignore no types
import type {
  AuctionBlueprintOnlineReactiveArgs,
  primitives,
} from '@adc/blueprint'
import type {
  UserListingAuthorization,
  ListingParty,
  Listing,
  OnlineAuctionSegment,
} from '@adc/sdk/types'
import { helpers } from '@adc/core-utils'
import moment from 'moment/moment'
import { CombinedListingType } from '../context/listing'
import { formatMoneyWithCentsExceptZero } from './formatters'

export const getListPrice = (
  listing: AuctionBlueprintOnlineReactiveArgs['listing']
) =>
  // TODO: remove as when formatters.js file is types
  formatMoneyWithCentsExceptZero(
    _.get(listing, 'valuation.seller_current_value_amount', 0)
  ) as number

const REGISTRATION_LIMIT_REACHED = 'REGISTRATION_LIMIT_REACHED'

interface GetRegistrationRestrictedValues {
  user: primitives.AuctionUser
  listing: AuctionBlueprintOnlineReactiveArgs['listing']
}

// TODO: the logic and types could use some cleanup but currently this is based off the original implementation that lived in firstlookmodalbutton
// and is now used in multiple places
export const getRegistrationRestrictedValues = ({
  user,
  listing,
}: GetRegistrationRestrictedValues) => {
  if (!user.logged_in) {
    return null
  }
  const userRestrictedRegisterToBid: UserListingAuthorization | undefined = (
    listing.is_current_user_allowed || []
  ).find(
    (restriction: UserListingAuthorization) =>
      restriction.action ===
      graph.enums.UserListingAuthorizationAction.OnlineBiddingRegistration
  )

  const isRegistrationButtonDisabled =
    userRestrictedRegisterToBid?.allowed === false
  const shouldShowRegistrationLimitReachedMessage =
    userRestrictedRegisterToBid?.reason_code === REGISTRATION_LIMIT_REACHED
  return {
    userRestrictedRegisterToBid,
    isRegistrationButtonDisabled,
    shouldShowRegistrationLimitReachedMessage,
  }
}

export const getContactAgentInfo = (listing: CombinedListingType) => {
  const listingParties = _.keyBy(listing.parties, 'party_role')
  const brokerParty = listingParties?.BROKER as ListingParty
  const listingAgentParty = listing.auction?.is_online
    ? listingParties.LISTING_AGENT
    : listingParties.FORECLOSURE_ATTORNEY
  return {
    listingAgency: brokerParty?.party_name || undefined,
    agentName: listingAgentParty?.party_name || undefined,
    agentPhone:
      brokerParty?.party_phone || listingAgentParty?.party_phone || undefined,
    agentEmail:
      brokerParty?.party_email || listingAgentParty?.party_email || undefined,
  }
}

export const isForeclosure = (listing: CombinedListingType) =>
  listing.listing_configuration?.asset_type ===
  graph.enums.AssetType.Foreclosure

export const eventDetailsUrl = (listing: Listing) => {
  const eventCode = get(listing, 'event.event_code', '')

  const eventDetailsQueryString = helpers.queryCollectionFormatter({
    venueID: listing.venue?.venue_id!,
    venueByDate: moment(
      get(listing, 'venue.venue_schedule.bid_start_local_date', '')
    ).format('YYYY-MM-DD'),
    state: get(
      listing,
      'primary_property.summary.address.country_primary_subdivision',
      ''
    ),
    county: get(
      listing,
      'primary_property.summary.address.country_secondary_subdivision',
      ''
    ),
  })

  return `/event/details/${eventCode}?${eventDetailsQueryString}`
}

export const isTPSOnline = (listing: Listing, segment: OnlineAuctionSegment) =>
  listing.listing_configuration?.asset_type ===
    graph.enums.AssetType.Foreclosure &&
  segment.__typename === 'OnlineAuctionSegment'
